import { lazy } from 'react';

// Types
import { OrderPersonalisationProps as LazyComponentProps } from './OrderPersonalisation.types';

// Components
import withSuspense, { lazyRetry } from '@components/suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "orderPersonalisation" */ './OrderPersonalisation')),
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(LazyComponent, 'OrderPersonalisation');

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as OrderPersonalisation };
